import { render, staticRenderFns } from "./MFormCheckbox.vue?vue&type=template&id=48eb4bac&"
import script from "./MFormCheckbox.vue?vue&type=script&lang=js&"
export * from "./MFormCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./MFormCheckbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports